import * as R from 'ramda';

import { TABLE_METRIC } from '../..';
import { EXPOSURE_KEY_CONFIG } from './constants';
import { isValueExist } from '@/utils/utils';
import {
    makeBreakdownFormat,
    makeMetricFormat,
} from '../utils';

/**
 * fieldListKey → raw data type (TABLE_METRIC | BREAKDOWN)
 * exposureListMap은 fieldListKey로 키잉되므로 역방향 조회 필요
 */
const FIELD_LIST_KEY_RAW_TYPE = Object.fromEntries(
    Object.values(EXPOSURE_KEY_CONFIG).map(({ fieldListKey, rawType }) => [
        fieldListKey,
        rawType,
    ])
);

export const getExposureRawType = (fieldListKey) =>
    FIELD_LIST_KEY_RAW_TYPE[fieldListKey];

/**
 * widget 의 데이터를 exposureList 에 필요한 데이터 형식으로 변환
 * - selectedField: object 형식
 *    - breakdown: {key: metric , isCustom: boolean}
 *    - metric: {key: metric , isCustom: boolean}
 * - fieldList: widget에 저장된 string[] 그대로 반환 (변환 없음)
 */
export const makeExposureData = ({ key, widget }) => {
    const config = EXPOSURE_KEY_CONFIG[key];

    if (!isValueExist(config)) {
        return { selectedField: { key: undefined }, fieldList: undefined };
    }

    const { rawType, fieldListKey, selectedPath, selectedDefault } = config;

    const selectedField = R.pathOr(selectedDefault, selectedPath, widget); // string
    const fieldList = R.path(['exposureList', fieldListKey])(widget);

    const makeFieldFormat =
        rawType === TABLE_METRIC ? makeMetricFormat : makeBreakdownFormat;

    return {
        selectedField: selectedField
            ? makeFieldFormat(selectedField)
            : undefined,
        fieldList,
    };
};

/**
 * combo chart widget 의 데이터를 exposureList 에 필요한 데이터 형식으로 변환
 * - selectedField: object 형식
 *   - combo metric: {key: metric , isCustom: boolean, type: 'bar'|'line', axisPosition: 'left'|'right'}
 * - fieldList: widget에 저장된 string[] 그대로 반환 (변환 없음)
 */
export const makeComboExposureData = ({ key, widget }) => {
    const config = EXPOSURE_KEY_CONFIG[key];
    if (!isValueExist(config)) {
        return { selectedField: { key: undefined }, fieldList: undefined };
    }

    const { fieldListKey, selectedPath } = config;

    const {
        metric = '',
        type = 'bar',
        axisPosition = 'left',
    } = R.pathOr({}, selectedPath)(widget); // object
    const fieldList = R.path(['exposureList', fieldListKey], widget);

    const selectedField = {
        ...makeMetricFormat(metric),
        type,
        axisPosition,
    };

    return {
        selectedField,
        fieldList,
    };
};
